<template>
  <nav class="navbar">
    <div class="container d-flex justify-content-between align-items-center">
      <!-- Logo -->
      <div class="logo">
        <img :src="logoImage" alt="Nolido" class="logo-img">
      </div>

      <!-- Navigation Menu (Desktop) -->
      <ul class="nav-menu">
        <li class="nav-item">
          <router-link to="/" class="nav-link">Accueil</router-link>
        </li>
        <li class="nav-item dropdown-wrapper" @mouseenter="showDropdown('about')" @mouseleave="hideDropdown('about')">
          <div class="dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false">
              À propos
            </a>
            <ul class="dropdown-menu" :class="{ show: dropdowns.about }">
              <li><router-link to="/about" class="dropdown-item">Qui sommes nous ?</router-link></li>
              <li><router-link to="/legal" class="dropdown-item">Mentions légales</router-link></li>
              <li><router-link to="/terms" class="dropdown-item">Conditions générales d'utilisation</router-link></li>
              <li><router-link to="/privacy" class="dropdown-item">Politiques de confidentialité</router-link></li>
            </ul>
          </div>
        </li>
        <li class="nav-item dropdown-wrapper" @mouseenter="showDropdown('offers')" @mouseleave="hideDropdown('offers')">
          <div class="dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false">
              Nos offres
            </a>
            <ul class="dropdown-menu" :class="{ show: dropdowns.offers }">
              <li><router-link to="/nlite" class="dropdown-item">N'Lite</router-link></li>
              <li><router-link to="/nbusiness" class="dropdown-item">N'Business</router-link></li>
              <li><router-link to="/nconsulting" class="dropdown-item">N'Consulting</router-link></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <router-link to="/contact" class="nav-link">Contactez nous</router-link>
        </li>
      </ul>

      <!-- Right Section (Desktop) -->
      <div class="nav-actions">
        <CustomButton
          label="Télécharger l'App" 
          @click="handleDownload"
        />
        <button class="btn-language">
          <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E%3Crect fill='%23ED2939' width='900' height='600'/%3E%3Crect fill='%23fff' width='600' height='600'/%3E%3Crect fill='%23002395' width='300' height='600'/%3E%3C/svg%3E" alt="FR" class="flag-icon">
        </button>
      </div>

      <!-- Hamburger Menu Button (Mobile) -->
      <button class="hamburger-menu" @click="toggleMobileMenu" :class="{ active: mobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Menu Dropdown -->
    <div class="mobile-menu" :class="{ show: mobileMenuOpen }">
      <ul class="mobile-nav-list">
        <li><router-link to="/" class="mobile-nav-link" @click="closeMobileMenu">Accueil</router-link></li>
        
        <li class="mobile-dropdown">
          <a href="#" class="mobile-nav-link" @click.prevent="toggleMobileDropdown('about')">
            À propos
            <i class="bi bi-chevron-down" :class="{ rotate: mobileDropdowns.about }"></i>
          </a>
          <ul class="mobile-submenu" :class="{ show: mobileDropdowns.about }">
            <li><router-link to="/about" class="mobile-nav-link" @click="closeMobileMenu">Qui sommes nous ?</router-link></li>
            <li><router-link to="/legal" class="mobile-nav-link" @click="closeMobileMenu">Mentions légales</router-link></li>
            <li><router-link to="/terms" class="mobile-nav-link" @click="closeMobileMenu">Conditions générales d'utilisation</router-link></li>
            <li><router-link to="/privacy" class="mobile-nav-link" @click="closeMobileMenu">Politiques de confidentialité</router-link></li>
          </ul>
        </li>
        
        <li class="mobile-dropdown">
          <a href="#" class="mobile-nav-link" @click.prevent="toggleMobileDropdown('offers')">
            Nos offres
            <i class="bi bi-chevron-down" :class="{ rotate: mobileDropdowns.offers }"></i>
          </a>
          <ul class="mobile-submenu" :class="{ show: mobileDropdowns.offers }">
            <li><router-link to="/nlite" class="mobile-nav-link" @click="closeMobileMenu">N'Lite</router-link></li>
            <li><router-link to="/nbusiness" class="mobile-nav-link" @click="closeMobileMenu">N'Business</router-link></li>
            <li><router-link to="/nconsulting" class="mobile-nav-link" @click="closeMobileMenu">N'Consulting</router-link></li>
          </ul>
        </li>
        
        <li><router-link to="/contact" class="mobile-nav-link" @click="closeMobileMenu">Contactez nous</router-link></li>
        
        <li class="mobile-cta">
          <CustomButton label="Télécharger l'App" @click="handleDownload" />
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';

export default {
  name: 'NavbarNolido',
  components: {
    CustomButton
  },
  data() {
    return {
      logoImage: require('@/assets/img/logo.png'),
      dropdowns: {
        about: false,
        offers: false
      },
      mobileMenuOpen: false,
      mobileDropdowns: {
        about: false,
        offers: false
      },
      hideTimeout: null
    }
  },
  methods: {
    showDropdown(name) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.dropdowns[name] = true;
    },
    hideDropdown(name) {
      this.hideTimeout = setTimeout(() => {
        this.dropdowns[name] = false;
      }, 200);
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      // Fermer tous les sous-menus si on ferme le menu principal
      if (!this.mobileMenuOpen) {
        this.mobileDropdowns.about = false;
        this.mobileDropdowns.offers = false;
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      this.mobileDropdowns.about = false;
      this.mobileDropdowns.offers = false;
    },
    toggleMobileDropdown(name) {
      this.mobileDropdowns[name] = !this.mobileDropdowns[name];
    },
    handleDownload() {
      console.log('Bouton Télécharger cliqué');
      this.closeMobileMenu();
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.navbar {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  padding: 0.75rem 0;
}

/* Logo */
.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  cursor: pointer;
}

.logo-img {
  width: 120px;
  object-fit: contain;
}

/* Navigation Menu */
.nav-menu {
  display: flex !important;
  flex-direction: row !important;
  list-style: none;
  gap: 2.5rem;
  flex: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
}

.dropdown-wrapper {
  position: relative;
}

.dropdown {
  position: relative;
  display: flex;
  align-items: center;
}

.nav-link {
  color: #1a1a1a !important;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 0.5rem 0;
  transition: color 0.3s ease;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.nav-link:hover {
  color: #F5A623 !important;
}

/* Dropdown Toggle Arrow */
.dropdown-toggle::after {
  content: '';
  display: inline-block;
  margin-left: 0.4rem;
  vertical-align: 0.15em;
  border-top: 0.35em solid;
  border-right: 0.35em solid transparent;
  border-bottom: 0;
  border-left: 0.35em solid transparent;
  transition: transform 0.3s ease;
}

.dropdown-wrapper:hover .dropdown-toggle::after {
  transform: rotate(180deg);
}

/* Dropdown Menu */
.dropdown-menu {
  display: none;
  position: absolute;
  top: calc(100% + 0.75rem);
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border: none;
  padding: 0.75rem 0;
  min-width: 280px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
}

.dropdown-menu.show {
  display: block;
  opacity: 1;
  visibility: visible;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Triangle indicator */
.dropdown-menu::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid white;
}

/* Pont invisible pour faciliter la transition */
.dropdown::after {
  content: '';
  position: absolute;
  top: 100%;
  left: -20px;
  right: -20px;
  height: 1rem;
  background: transparent;
}

.dropdown-item {
  padding: 0.85rem 1.5rem;
  color: #1a1a1a;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  display: block;
  position: relative;
  overflow: hidden;
}

.dropdown-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
  background: linear-gradient(90deg, #F5A847 0%, transparent 100%);
  transition: width 0.3s ease;
  z-index: 0;
}

.dropdown-item:hover::before {
  width: 100%;
}

.dropdown-item:hover {
  background: #FFF5E8;
  color: #F5A847;
  border-left-color: #F5A847;
  padding-left: 1.75rem;
}

.dropdown-item:focus,
.dropdown-item:active {
  background: #FFF5E8;
  color: #F5A847;
  outline: none;
}

/* Séparateur entre items */
.dropdown-item + .dropdown-item {
  border-top: 1px solid #f5f5f5;
}

/* Right Actions */
.nav-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.btn-language {
  background: white;
  border: 2px solid #e5e5e5;
  border-radius: 8px;
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  transition: all 0.3s ease;
}

.btn-language:hover {
  border-color: #F5A623;
  transform: scale(1.05);
}

.flag-icon {
  width: 24px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
}

/* Responsive */
@media (max-width: 1024px) {
  .navbar .container {
    gap: 2rem;
  }
  
  .nav-menu {
    gap: 1.5rem;
  }
}

/* Hamburger Menu Button */
.hamburger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.hamburger-menu span {
  display: block;
  width: 100%;
  height: 3px;
  background-color: #1a1a1a;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.hamburger-menu.active span:nth-child(1) {
  transform: translateY(10.5px) rotate(45deg);
}

.hamburger-menu.active span:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.active span:nth-child(3) {
  transform: translateY(-10.5px) rotate(-45deg);
}

/* Mobile Menu */
.mobile-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  z-index: 999;
}

.mobile-menu.show {
  max-height: 600px;
  overflow-y: auto;
}

.mobile-nav-list {
  list-style: none;
  padding: 1rem 0;
  margin: 0;
}

.mobile-nav-list > li {
  border-bottom: 1px solid #f5f5f5;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  color: #1a1a1a;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.mobile-nav-link:hover {
  background: #FFF5E8;
  color: #F5A847;
}

.mobile-dropdown .mobile-nav-link i {
  font-size: 14px;
  transition: transform 0.3s ease;
}

.mobile-dropdown .mobile-nav-link i.rotate {
  transform: rotate(180deg);
}

.mobile-submenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: #f8f8f8;
}

.mobile-submenu.show {
  max-height: 400px;
}

.mobile-submenu .mobile-nav-link {
  padding-left: 2.5rem;
  font-size: 15px;
}

.mobile-cta {
  padding: 1rem 1.5rem;
  border-top: 2px solid #f5f5f5;
}

@media (max-width: 768px) {
  .nav-menu,
  .nav-actions {
    display: none;
  }
  
  .hamburger-menu {
    display: flex;
  }
  
  .mobile-menu {
    display: block;
  }
  
  .navbar .container {
    justify-content: space-between;
  }
}
</style>